import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import ListTableCard from './ListTableCard';
import { ICommonCode, IProject } from 'utils/types/storyTypes';
import { Pagination } from 'antd';

interface IProps {
  data: IProject[] | undefined;
  langList: ICommonCode[] | null;
}

const ListTable: React.FC<IProps> = ({ data, langList }) => {
  const [projectData, setProjectData] = useState<IProject[] | undefined>(
    undefined,
  );
  useEffect(() => {
    if (data) {
      // set page data of pagination
      handleChangePage(1, 8, data, setProjectData);
    }
  }, [data]);

  const handleChangePage = (
    page: number,
    itemsPerPage: number,
    data: IProject[],
    setData: (data: IProject[]) => void,
  ) => {
    if (data) {
      // Calculate the start and end indices for the current page
      const startIndex = (page - 1) * itemsPerPage;
      const endIndex = startIndex + itemsPerPage;
      // Slice the data array to get the items for the current page
      const items = data.slice(startIndex, endIndex);
      setData(items);
    }
  };

  return (
    <div>
      <ListTableWrapper>
        {projectData?.map((item) => {
          const lang = langList?.find((e) => e.code === item?.default_lang);
          return (
            <ListTableCard key={item.project_id} data={item} lang={lang} />
          );
        })}
      </ListTableWrapper>
      {projectData && data && data.length >= 8 && (
        <PaginationWrapper
          showSizeChanger={false}
          defaultCurrent={1}
          pageSize={8}
          total={data.length}
          onChange={(page, pageSize) => {
            if (projectData && data) {
              handleChangePage(page, 8, data, setProjectData);
            }
          }}
        />
      )}
    </div>
  );
};

export default ListTable;

const ListTableWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  grid-gap: 22px;
  justify-content: space-between;
`;

const PaginationWrapper = styled(Pagination)`
  text-align: center;
  margin-top: 3rem;
`;
